module.exports = __webpack_public_path__ + "img/max-white.2e423b92.svg";